import React from 'react';
import data from '../../../data/blogs.json';
function Blog() {
  return (
    <div className="sec-box blog section-padding bord-thin-top" id="blog">
      <div className="sec-head mb-80">
        <div className="row">
          <div className="col-lg-6 wow fadeInUp">
            <h6 className="sub-title opacity-7 mb-15">Our Blog</h6>
            <h3>
              <span className="main-color">Blog</span>
            </h3>
          </div>
          <div className="col-lg-6 valign">
            <div className="go-more full-width d-flex justify-content-end">
              <a href="/blogs" className="d-flex">
                <span>
                  View All Posts{' '}
                  <svg
                    className="arrow-right"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 34.2 32.3"
                    style={{ strokeWidth: 2 }}
                  />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {data?.slice(0, 3).map((item, index) => (
          <div key={index} className="col-lg-4">
            <div className="item md-mb30 wow fadeIn" data-wow-delay=".2s">
              <div className="img">
                <img src={item.photo} alt="" />
              </div>
              
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;
